<template>
    <div class="row justify-content-center">
        <div v-for="item in items" :key="item.id" class="col-lg-4 col-md-6 wow move-up">
            <div class="service-grid">
                <div class="ht-service-box--two text-center style-03">
                    <router-link to="">
                        <div class="image mb-20">
                            <img :src="item.icon" class="img-fluid" alt="aeroland-startup-box-icon-01">
                        </div>
                        <div class="content">
                            <h6 class="heading" v-html="item.heading"></h6>
                            <div class="service_text" v-html="item.text"></div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StartUpFeatureTwo',
        data (){
            return {
                items: [
                    {
                        icon: require('../assets/img/icons/aeroland-startup-box-icon-02.png'), 
                        heading: "Personalizzabile", 
                        text: "<strong>Il nostro punto di forza!</strong><br/>Con Bacco Lab puoi modificare in autonomia tutte le configurazioni della tua cantina, in modo intuitivo e con pochi click."
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-startup-box-icon-03.png'), 
                        heading: "Una visione d'insieme", 
                        text: "Crea la tua mappa.<br/>Con Bacco Lab puoi creare la mappa della tua cantina. Con vasche, macchinari e linee di produzione sempre aggiornate."
                    },
                    {
                       icon: require('../assets/img/icons/aeroland-startup-box-icon-01.png'), 
                       heading: "Tracciabilità", 
                       text: "Sempre all'avanguardia.<br/>Grazie alle nostre competenze vi offriamo un sistema di tracciabilità moderno dal conferimento all'imbottigliamento."
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-startup-box-icon-04.png'), 
                        heading: "Bacco Lab Ovunque", 
                        text: "Dove vuoi, quando vuoi!<br/>Bacco Lab è disponibile per qualsiasi piattaforma. Web, Desktop, Mobile. Ogni versione ha le sue funzionalità, che aspetti? Prenota una demo!"
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-startup-box-icon-05.png'), 
                        heading: "User Experience", 
                        text: "Pensato per voi.<br/>Bacco Lab è stato pensato e creato secondo i più moderni dettami della User Experience, con il contribuito di Cantine ed Enologi di primo livello."
                    },
                    // {
                    //     icon: require('../assets/img/icons/aeroland-startup-box-icon-06.png'), 
                    //     heading: this.$t("message.andSoOn"), 
                    //     text: this.$t("message.andSoOnText")
                    // },
                ]
            }
        }
    }
</script>
